import AppGlobalSettings from "@app/AppGlobalSettings"

export const useShouldUseNativeTabBar = (supportsNativeTabs: boolean | undefined) =>
    AppGlobalSettings.isNative() && supportsNativeTabs === true
